<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Wprowadź dane faktury"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <w-input class="col-md-12 form-group" :model="$schema.nip" />

      <w-datepicker class="col-md-12 form-group" :model="$schema.date" />

      <w-input class="col-md-12 form-group" :model="$schema.number" />

      <w-input class="col-md-12 form-group" :model="$schema.price" />

      <w-input class="col-md-12 form-group" :model="$schema.priceToPay" />
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/invoice.schema';

// @vuese
// Modal faktury
// @group Document
export default {
  mixins: [manageMixin('invoice', {})],
  schema,
  props: {
    // Maksymalna kwota do wypłaty
    maxToPay: { type: Number, default: 0 },

    // Lista faktur
    invoices: { type: Array }
  },

  computed: {
    ...mapState({
      // Dokument dla którego jest edytowana faktura
      document: state => state.documentIndex.data
    }),
    // Inne niż aktualnie edytowana faktury
    otherInvoices() {
      return this.invoices?.filter(invoice => invoice.id !== this.id) || [];
    }
  },

  watch: {
    maxToPay() {
      this.refreshExternal();
    },

    otherInvoices() {
      this.refreshExternal();
    }
  },

  mounted() {
    this.refreshExternal();
  },

  methods: {
    // @vuese
    // Odświeża zewnętrzne dane do obliczeń w schemie
    refreshExternal() {
      this.$options.external = { document: this.document, maxToPay: this.maxToPay, otherInvoices: this.otherInvoices };
      this.$setSchema(schema);
      this.$schema.$reset();
    }
  }
};
</script>
